import { useMemo } from 'react';

import { fromPromise } from 'xstate5';

import { Allergen } from '@sg/graphql-schema';
import { type DietaryPreferencesMachineImplementations } from '@sg/shared-fe-features-menu';

import { useUpdateDietaryPreferencesWithAllergensMutation } from './graphql/CustomerDietaryPreferences.generated';
import { getDietaryPreferencesList } from './helpers';

// ─────────────────────────────────────────────────────────────────────────────

export const useUpdateDietaryPreferencesActor = () => {
  const [, updatePreferencesWithAllergens] = useUpdateDietaryPreferencesWithAllergensMutation();

  return useMemo<UpdateCustomerDietaryPreferences>(
    () =>
      fromPromise(async (args) => {
        const { input } = args;
        const { pendingPreferences } = input;

        const { error } = await updatePreferencesWithAllergens({
          input: {
            allergens: getDietaryPreferencesList(pendingPreferences) as Allergen[],
          },
        });

        if (error) {
          throw new Error('Failed to update customer dietary preferences');
        }
      }),
    [updatePreferencesWithAllergens],
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UpdateCustomerDietaryPreferences = NonNullable<
  NonNullable<DietaryPreferencesMachineImplementations['actors']>['updateRemotePreferences']
>;
